import { useEffect } from 'react';
import {
  RESTORABLE_MFA_STEPS,
  saveMfaFlow,
  readMfaFlow,
  clearMfaFlow,
} from '../mfaFlowStorage';

/**
 * Mantém o step do cadastro MFA no sessionStorage para sobreviver ao F5 e o
 * restaura no carregamento. O `currentStep` é reidratado de forma síncrona no
 * lazy init do `useState` (em index.js); aqui recarregamos os dados do step.
 */
export default function useMfaFlowPersistence({
  currentStep,
  setCurrentStep,
  formikBag,
  auth,
  steps,
}) {
  // Writer: espelha o step atual no storage (limpa quando sai do fluxo).
  useEffect(() => {
    if (RESTORABLE_MFA_STEPS.includes(currentStep.key)) {
      saveMfaFlow({
        step: currentStep.key,
        user: formikBag.values.mfaUser,
        app: formikBag.values.mfaApp,
        mandatory: !!formikBag.values.mfaEnrollmentSession,
      });
    } else {
      clearMfaFlow();
    }
  }, [currentStep]); // eslint-disable-line react-hooks/exhaustive-deps

  // Restore (uma vez, no F5): reidrata os dados que não vão para o storage.
  useEffect(() => {
    const flow = readMfaFlow();
    if (!flow) return;

    // Reidrata o usuário (usado no "Agora não") em qualquer step restaurado.
    if (flow.user) {
      formikBag.setFieldValue('mfaUser', flow.user);
    }

    // Reidrata o app escolhido para o Enroll exibir o tutorial certo após F5.
    if (flow.app) {
      formikBag.setFieldValue('mfaApp', flow.app);
    }

    // O QR não é persistido: regenera a associação ao voltar no mfaEnroll.
    // Fluxo obrigatório nunca chega aqui (ver mfaFlowStorage), mas o call
    // site escolhe pela sessão por consistência com LoginMfaInstallApp.
    if (flow.step === 'mfaEnroll') {
      const associate = formikBag.values.mfaEnrollmentSession
        ? auth.associateMfaEnrollment(formikBag.values.mfaEnrollmentSession)
        : auth.associateToken();
      associate
        .then(association => {
          formikBag.setFieldValue('mfaSecret', association?.secret);
          formikBag.setFieldValue('mfaOtpUri', association?.otpAuthUri);
        })
        .catch(() => {
          clearMfaFlow();
          setCurrentStep(steps.email);
        });
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
}
